import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import TextField from '../../../components/TextField';
import CardArrecadacao from './components/CardArrecadacao';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//API
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';
import gereciamentoArrecadacao_api from '../../../api/gereciamentoArrecadacao_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos, isDateOverflow } from '../../../helpers/ValidadorDeCampos';
import { criarOnChangeMultiSelect } from '../../../helpers/onChangeMultiSelect';
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Shared
import analiseInfracao_api from '../../../api/analiseInfracao_api';
import { useLocation, useNavigate } from 'react-router-dom';


function initialStateConsultaGerenciamentoDeArrecadacao() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);
    return {
        tipoBusca: 'Data de Infração',
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
        tipoFiscalizacao_Ids: [],
        numeroInfracao: "",
        logradouro: '',
        numero: '',
        bairro: '',
        nome: '',
        statusBoleto: 'Todos'
    }
}

function GerenciamentoDeArrecadacao() {
    // Tipo de Busca [Data da Infração, Data do Boleto, Vencimento do Boleto], Data Inicial, Data Final, Tipo de Fiscalização, Infração, Endereço, Nome, Status do Boleto
    //State para consultar Gereciamento de Arrecadação
    const [consultaGerenciamentoDeArrecadacao, setConsultaGerenciamentoDeArrecadacao] = useState(initialStateConsultaGerenciamentoDeArrecadacao());

    //State para pegar lista dos tipos de fiscalizacao
    const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

    //State para cards
    const [listaArrecadacao, setListaArrecadacao] = useState([]);

    //State para pegar o tipo de Arrecadação
    const [tipoArrecadacao, setTipoArrecadacao] = useState(null);

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    //Estado que pega os dados passados via navegação
    const location = useLocation();

    //Estado de navegação
    const navigate = useNavigate();

    //pegando a etapa selecionada no 
    const { filtro } = location.state ? location.state : {};

    const loadTipoDeFiscalizacao = () => {
        setLoading(true);
        tipoDeFiscalizacao_api.getList()
            .then(response => {
                response.data.map(value => {
                    value.value = value.id;
                    value.label = value.identificacao;
                    return value;
                })
                //Sem a opção "Todos": nenhum tipo selecionado já significa todos os tipos
                setListTipoDeFiscalizacao(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    };

    const loadGerenciamentoArrecadacao = (filtro = null) => {
        setListaArrecadacao([]);
        setTipoArrecadacao(null);

        setLoading(true);
        gereciamentoArrecadacao_api.GetConsultaGerenciamentoArrecadacao(filtro != null ? filtro : consultaGerenciamentoDeArrecadacao)
            .then(response => {
                setListaArrecadacao(response.data)
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadTipoDeFiscalizacao();

        if (filtro) {
            setConsultaGerenciamentoDeArrecadacao({ ...filtro });
            handleConsultaArrecadacao(filtro)
        }
    }, []);

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "Identificação da Infração", objectValue: "infracao_Identificacao", align: "left" },
        { value: "Número Guia", objectValue: "numeroGuia", align: "left" },
        { value: "Status do Boleto", objectValue: "statusBoleto", align: "left" },
        { value: "Valor da Multa", objectValue: "valorMulta", align: "left" },
        {
            value: "Data de Vencimento", objectValue: "dataVencimento", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(tipoArrecadacao?.listaFiscalizacaoInfratores[dataIndex].dataVencimento).format("DD/MM/YYYY")}</>
                }
            }
        },
        { value: "Data Pagamento", objectValue: "dataPagamento", align: "left" },
        { value: "Nome do Infrator", objectValue: "nomeInfrator", align: "left" },
    ];

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "tipoBusca", required: true }),
        objCampo({ name: "statusBoleto", required: true })
    ]);

    const datatipoBusca = [
        { value: "Data de Infração", label: "Data de Infração" },
        { value: "Data do Boleto", label: "Data do Boleto" },
        { value: "Vencimento do Boleto", label: "Vencimento do Boleto" },
        { value: "Data de Pagamento", label: "Data de Pagamento" },
    ];

    const dataStatusBoleto = [
        { value: "Todos", label: "Todos" },
        { value: "Registrado", label: "Registrado" },
        { value: "Cancelado", label: "Cancelado" },
        { value: "Vencido", label: "Vencido" },
        { value: "Liquidado", label: "Liquidado" },
    ];

    //Função para pegar o id da infração
    const visualizarFiscalizacao = (rowData) => {
        navigate("/admin/ficha-infracao", { state: { infracao_id: rowData.fiscalizacaoInfracao_Id, filtro: consultaGerenciamentoDeArrecadacao, originPath: "/admin/gerenciamentoDeArrecadacao" } })
    }

    const handleConsultaBoleto = (rowData) => {
        if (rowData?.fiscalizacaoInfracaoBoleto_Id) {
            setLoading(true);
            analiseInfracao_api.GetConsultarCobranca(rowData.fiscalizacaoInfracaoBoleto_Id)
                .then(response => {
                    loadGerenciamentoArrecadacao();
                })
                .catch(error => showMessage("Error", error?.message ?? "Error na operação", "error", null))
                .finally(() => setLoading(false))
        }
    }

    const consultaBoletoFunction = (rowData, actionStyle) => {
        if (rowData.statusBoleto == "Registrado" || rowData.statusBoleto == "Vencido") {
            return actionsTable.consultaBoleto(() => handleConsultaBoleto(rowData));
        } else {
            return null;
        }
    }

    //Variavel que guarda as ações da tabela
    const actions = [
        actionsTable.visualizar(visualizarFiscalizacao),
        actionsTable.imprimir(() => console.log("imprimir")),
        consultaBoletoFunction
    ];

    //

    const onChangeGerenciamentoDeArrecadacao = (value, e) => {
        const _consultaGerenciamentoDeArrecadacao = {
            ...consultaGerenciamentoDeArrecadacao,
            [e.name]: value ? value.value.toString() : null,
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_consultaGerenciamentoDeArrecadacao, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setConsultaGerenciamentoDeArrecadacao(_consultaGerenciamentoDeArrecadacao);
    }

    const onChangeMultiSelectGerenciamentoDeArrecadacao = criarOnChangeMultiSelect({
        state: consultaGerenciamentoDeArrecadacao,
        setState: setConsultaGerenciamentoDeArrecadacao
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setConsultaGerenciamentoDeArrecadacao({
            ...consultaGerenciamentoDeArrecadacao,
            [name]: value
        })
    }

    const handleConsultaArrecadacao = (filtro = null) => {
        if (!filtro) {
            //Realizando a validação dos campos obrigatorios
            const _errors = validarCampos(consultaGerenciamentoDeArrecadacao, campos);
            setErrors(_errors[0]);

            if (_errors[1].length > 0)
                return true;

            //Data Inicial/Final são opcionais quando o Nome do Infrator for informado
            const possuiFiltroAlternativo = !!consultaGerenciamentoDeArrecadacao.nome?.trim();

            if (!possuiFiltroAlternativo && (!consultaGerenciamentoDeArrecadacao.dataInicial || !consultaGerenciamentoDeArrecadacao.dataFinal)) {
                showMessage("Aviso", "Informe o período de datas ou o Nome do Infrator.", "warning", null);
                return true;
            }

            if (consultaGerenciamentoDeArrecadacao.dataInicial && consultaGerenciamentoDeArrecadacao.dataFinal &&
                isDateOverflow(consultaGerenciamentoDeArrecadacao.dataInicial, consultaGerenciamentoDeArrecadacao.dataFinal, 12, 'months')) {
                showMessage("Aviso", "A pesquisa deve ter um período máximo de 12 meses!", "warning", null);
                return true;
            }
        }

        loadGerenciamentoArrecadacao(filtro);
    }

    return <>
        <h4 className='text-secondary m-0'>Gerenciamento de Arrecadação</h4>
        <Row className='mt-3'>
            <Col md={12} lg={3}>
                <TextField
                    type={"select"}
                    name={"tipoBusca"}
                    label={"* Tipo de Busca"}
                    searchable
                    options={datatipoBusca}
                    onChange={onChangeGerenciamentoDeArrecadacao}
                    value={
                        datatipoBusca.filter(value => value.value == consultaGerenciamentoDeArrecadacao.tipoBusca)
                            .map(v => { return { value: v.value, label: v.value } })
                    }
                    invalid={!!errors.tipoBusca}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"select"}
                    name={"statusBoleto"}
                    label={"* Status Boleto"}
                    searchable
                    options={dataStatusBoleto}
                    onChange={onChangeGerenciamentoDeArrecadacao}
                    value={
                        dataStatusBoleto.filter(value => value.value == consultaGerenciamentoDeArrecadacao.statusBoleto)
                            .map(v => { return { value: v.value, label: v.value } })
                    }
                    invalid={!!errors.statusBoleto}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"date"}
                    name={"dataInicial"}
                    label={"Data Inicial"}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.dataInicial}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"date"}
                    name={"dataFinal"}
                    label={"Data Final"}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.dataFinal}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"select"}
                    name={"tipoFiscalizacao_Ids"}
                    label={"Tipo de Fiscalização"}
                    placeholder={"Todos"}
                    multiple
                    options={listTipoDeFiscalizacao}
                    onChange={onChangeMultiSelectGerenciamentoDeArrecadacao}
                    value={listTipoDeFiscalizacao.filter(value => (consultaGerenciamentoDeArrecadacao.tipoFiscalizacao_Ids ?? []).includes(value.value))}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"text"}
                    name={"numeroInfracao"}
                    label={" Número da infração"}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.numeroInfracao}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"text"}
                    name={"nome"}
                    label={" Nome"}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.nome}
                />
            </Col>


            <Col md={12} lg={3}>
                <TextField
                    type={"text"}
                    name={"bairro"}
                    label={" Bairro"}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.bairro}
                />
            </Col>
            <Col md={12} lg={4}>
                <TextField
                    type={"text"}
                    name={"logradouro"}
                    label={"* Logradouro"}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.logradouro}
                />
            </Col>
            <Col md={12} lg={2}>
                <TextField
                    type={"text"}
                    name={"numero"}
                    label={"Numero"}
                    mask={mascaras.numeroMask}
                    onChange={onChange}
                    value={consultaGerenciamentoDeArrecadacao.numero}
                />
            </Col>
        </Row>
        <Row className='text-center align-items-center'>
            <Col md={12} lg={12}>
                <Button
                    color='primary'
                    className='text-white fw-bold'
                    onClick={() => handleConsultaArrecadacao()}
                >
                    <FontAwesomeIcon icon={faFilter} /> Filtrar
                </Button>
            </Col>
        </Row>
        <Row className='mt-4'>
            {listaArrecadacao?.tipoArrecadacao?.length > 0 && <CardArrecadacao
                listaDeArrecadacao={listaArrecadacao.tipoArrecadacao}
                setTipoArrecadacao={setTipoArrecadacao}
            />}
        </Row>
        <Row>
            {tipoArrecadacao &&
                <TabelaListagem
                    actions={actions}
                    title={`Lista de boletos ${tipoArrecadacao.status.toLowerCase()}s`}
                    options={{ print: false, search: true, pagination: true }}
                    headers={headers}
                    items={tipoArrecadacao?.listaFiscalizacaoInfratores}
                />
            }
        </Row>
    </>;
}

export default GerenciamentoDeArrecadacao;
